import { render, staticRenderFns } from "./CalendarDayColor.vue?vue&type=template&id=9485fd1e"
import script from "./CalendarDayColor.ts?vue&type=script&lang=ts&external"
export * from "./CalendarDayColor.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports